import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { BrandService  } from '../../../_services/brand.service';
import { Observable } from 'rxjs';
import { UserService,  } from '../../../_services/user.service';
import { UserModel, BrandModel } from "../../../_models/subjects";
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormErrorsService } from '../../../_services/form-errors.service';
import { debounceTime, distinctUntilChanged, first } from 'rxjs/operators';
import { VelvetysoftService } from '../../../_services/velvetysoft.service';
import { OpenaiService } from 'src/app/_services/openai.service';




@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html',
  styleUrls: ['./send-email.component.scss']
})
export class SendEmailComponent implements OnInit {
  public Editor = ClassicEditor;
  form: UntypedFormGroup;
  brandUsers: Observable<UserModel[]>;
  //$brand: Observable<BrandModel>;
  directions: string;
  extra: boolean = false;
  addNextSteps: boolean = false;
  bid: any;
  hasPreview: boolean = false;
  previewResults: Observable<any>;
  @ViewChild('iframe') iframe: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SendEmailComponent>,    
    private brandService: BrandService,
    private userService: UserService,
    private formErrors: FormErrorsService,
    public vs: VelvetysoftService,
    private openaiService: OpenaiService,
    fb: UntypedFormBuilder,
  ) { 
    this.form = fb.group({
      to: [[]],
      cc: [[]],
      bcc: [[]],
      replyTo: [[]],
      // content: ['', Validators.required],
      subject: [''],
      show_next_steps: [],
      message: [],
      iid: data[this.data.subject].id
    });
  }

  ngOnInit() {
    //console.log(this.data,this.data[this.data.subject].brand_id);
    //ISSUE HERE WHERE PROPOSALs AND MAYBE INVOICES HAVE A NESTED VALUE IN A COLLECTION OF PHASES...
    if (this.data[this.data.subject] && this.data[this.data.subject].brand_id ){
      this.bid = this.data[this.data.subject].brand_id;      
    }

    this.userService.userProfile()
      .pipe(first())
      .subscribe( profile => {
        this.form.controls.replyTo.value.push( profile.user);
        this.form.controls.cc.value.push( profile.user);      
    })

    //sewtup a preview window
    
    //AUTO PREVIEW SECTION
    if(this.data?.endpoint ) this.data.subject = this.data.endpoint;
    let previewContent = ['invoice','invoice-overdue','round'];
    if(previewContent.includes(this.data.subject)){
      this.hasPreview = true;
      this.form.valueChanges
      .pipe(
        debounceTime(1200)
      ).subscribe(val => {        
        console.log(val);
        if(val.to.length < 1) return;
        this.preview();        
      });
    }    
   
      
    
    //END AUTO PREVIEW SECTION



    //this.formErrors.attach(this.form);

    //VALIDATION
    // this.form.get('to').valueChanges.subscribe(val =>{
    //   console.log(val);
    // })
    this.formErrors.errors.subscribe(errors =>{
      if(!errors) return
      if( errors['email.to'] ){
        errors['to'] = errors['email.to'];
        delete (errors['email.to'])
      }
      this.formErrors.apply(this.form,errors);
    })


        
    // setTimeout(() => {  
    //   this.openaiService.prompt({directions: this.directions })
    //     .pipe(first())
    //     .subscribe( res => {      
    //       this.form.patchValue({ message: res });
    //    });
    // }, 100);
      
    // })

    //update the form propert: message
    this.form.patchValue({ message: this.vs.emailMessage(this.data.subject) });
    //{'message': 
  }

  //MOVE TO OPEN AI SERVICE
  generateDirections(data){    
    
    if(!data) return "introduction for an email";

    if(data.subject == 'invoice'){
      let title = (data.invoice.title)
        ? `for ${data.invoice.title}`
        : '';
      let client = (this.form?.value?.to[0]?.name)
        ? `:${this.form.value.to[0].name}`
        : '';
      let from = (this.form?.value?.replyTo[0]?.name)
        ? `from:${this.form.value.replyTo[0].name}`
        : '';
      return `write a short friendly email body to a client ${client} that the ${title} is attached ${from}, no subject is line needed`
    }

    if(data.subject == 'proposal'){
      let title = (data.proposal.title)
        ? `for ${data.proposal.title}`
        : '';
      let client = (this.form?.value?.to[0]?.name)
        ? `:${this.form.value.to[0].name}`
        : '';
      let from = (this.form?.value?.replyTo[0]?.name)
        ? `from:${this.form.value.replyTo[0].name}`
        : '';
      return `write a short email body to a client${client} that the proposal ${title} is attached ${from}, no subject is line needed`
    }

    if(data.subject == 'round'){
      let title = (data.round.title)
        ? `for ${data.round.title}`
        : '';
      let client = (this.form?.value?.to[0]?.name)
        ? `:${this.form.value.to[0].name}`
        : '';
      let from = (this.form?.value?.replyTo[0]?.name)
        ? `from:${this.form.value.replyTo[0].name}`
        : '';      

      let description = (data.round.description)
        ? `a description of the round updates: ${data.round.description}`
        : '';      
        
      return `write a short email body, no subject line needed, to a client${client} that the round ${title} has the updated info and files attached ${from} ${description}`
    }

    if(data.subject == 'brief'){
      
      let client = (this.form?.value?.to[0]?.name)
        ? `:${this.form.value.to[0].name}`
        : '';
      let from = (this.form?.value?.replyTo[0]?.name)
        ? `from:${this.form.value.replyTo[0].name}`
        : '';      
              
      return `write a short email body, no subject line needed, to a client${client} that the brief is attached ${from} `
    }
  }
  
  prompt(form,field){    
    this.directions = this.generateDirections(this.data);
    let prompt = form.value[field];
    this.openaiService.openPrompt(this.directions)
    .subscribe(result => {
        let data = [];
        result = result.replace(/\r?\n|\r/g, '<br>').replace(/^<br><br>/, '');
        data[field] = result;
        form.patchValue(data);
    });
  }

  getBrandUsers(bid): Observable<BrandModel>{
    if(bid){
      return this.brandService.brand(bid);
    }
  }

  send() {
    this.dialogRef.close({ status: true, email: this.form.value });
  }

  preview() {    
    //THIS IS AN AUTO GENERATED PREVIEW
    //ELSE IT"S OPEN IN A NEW WINDOW
    if(this.hasPreview){
      let options = {autoPreview: true};
      let _iframe = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
      console.log('previewing email',this.iframe);
      this.data.emit({ email: this.form.value}, options).subscribe( res => {
          
        _iframe.open();
        _iframe.write(res);
        _iframe.close();
      });
    }else{
      this.data.emit({ email: this.form.value });
    }
    
    //this.dialogRef.close({ status: 'preview', email: this.form.value });
  }

  close() {
    this.dialogRef.close();
  }

}
